/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { AuthStates, Audience } from '@vis-auth/vis-auth';
import { Route, RouteProps } from 'react-router-dom';
import { useAuthState } from '../utils/AuthStateContext';
import AuthRedirect from './AuthRedirect';

export type SecureRouteProps = RouteProps & { audiences?: Audience[] };

const doesAudienceMatch = (audiences: Audience[] | undefined, curAud: Audience | undefined): boolean => {
  if (!audiences) {
    return true;
  }

  return curAud ? audiences.includes(curAud) : false;
};

export const redirectRoute = (props: RouteProps) => (
  <Route {...props} component={AuthRedirect}>
    {null}
  </Route>
);

export function SecureRoute(props: SecureRouteProps) {
  const { state, audience } = useAuthState();
  const { audiences, ...routeProps } = props;

  switch (state) {
    case AuthStates.authenticated:
      return doesAudienceMatch(audiences, audience) ? <Route {...routeProps} /> : redirectRoute(routeProps);
    case AuthStates.unauthenticated:
      return redirectRoute(routeProps);
    default:
      return null;
  }
}
